<template>
    <div>
        <game-fps-item
            v-for="game in sessionGamesData"
            :key="`fps-game-${game.id}`"
            :game="game"
            :fps="+game.game_value"
            image-key="image"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import GameFpsItem from "@c/store/build/game-fps-item";

export default {
    name: "GamesInfo",
    components: {
        GameFpsItem
    },
    computed: {
        ...mapGetters(["sessionGamesData"]),
    },
}
</script>
